import {
  FilterItemNode,
  ResourceExplorerFilterProvider,
} from "@/services/cloudchipr.api";

export const generateFilterTreeForPathProviderGrouping = (
  provider: ResourceExplorerFilterProvider,
  accounts?: string[],
): FilterItemNode => ({
  node_type: "item",
  type: "account",
  filter_provider: provider,
  value: accounts,
  operator: "in",
});
